import React from "react";

export const InputLabel = ({ children }) => (
  <p className="mb-2 text-xs font-medium uppercase tracking-[0.18em] text-slate-500">
    {children}
  </p>
);

export const DesktopIcon = ({ className = "h-3.5 w-3.5" }) => (
  <svg
    className={className}
    viewBox="0 0 256 256"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M28,96v68a4.00427,4.00427,0,0,0,4,4h76a12,12,0,0,1,0,24h-8v12h8a12,12,0,0,1,0,24H68a12,12,0,0,1,0-24h8V192H32A28.03146,28.03146,0,0,1,4,164V96A28.03146,28.03146,0,0,1,32,68h76a12,12,0,0,1,0,24H32A4.00427,4.00427,0,0,0,28,96Zm152-8h24a12,12,0,0,0,0-24H180a12,12,0,0,0,0,24Zm0,36h24a12,12,0,0,0,0-24H180a12,12,0,0,0,0,24Zm72-76V208a20.0226,20.0226,0,0,1-20,20H152a20.0226,20.0226,0,0,1-20-20V48a20.0226,20.0226,0,0,1,20-20h80A20.0226,20.0226,0,0,1,252,48Zm-24,4H156V204h72ZM192,160a16,16,0,1,0,16,16A16.01833,16.01833,0,0,0,192,160Z" />
  </svg>
);

export const MonitorIcon = ({ className = "h-3.5 w-3.5" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2.5" />
    <line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);
